import React, { useEffect, useState } from 'react';
import { PhotoIcon,TrashIcon } from '@heroicons/react/24/solid';
import { authAxios } from '../../config/config';
import { toast } from 'react-toastify';

const AddPatient = ({ handleCancel, handleAdd, allmodel, handleUpdate }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    gender: '',
    medicalCase: '',
    attachments: [],
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAttachmentUpload = async (e) => {
    const file = e.target.files[0];
    const uploadData = new FormData();
    uploadData.append('file', file);

    await authAxios()
      .post('/admin/upload/single', uploadData)
      .then((response) => {
        const resData = response.data;
        toast.success(resData.message);
        setFormData((prev) => ({
          ...prev,
          attachments: [...prev.attachments, resData.data.url],
        }));
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };




    const handleImageUpload = async (field, files) => {
      const uploadedImages = [];
      const uploadPromises = Array.from(files).map(async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        try {
          const response = await authAxios().post('/admin/upload/single', formData);
          uploadedImages.push(response.data.data.url);
          toast.success('Image uploaded successfully!');
        } catch (error) {
          toast.error('Failed to upload image.');
        }
      });
  
      await Promise.all(uploadPromises);
      setFormData((prev) => ({
        ...prev,
        [field]: [...prev[field], ...uploadedImages]
      }));
    };
  
    const handleRemoveImage = (field, index) => {
      setFormData((prev) => ({
        ...prev,
        [field]: prev[field].filter((_, i) => i !== index)
      }));
    };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = { ...formData };

    console.log("dasdasdas", payload)

    if (allmodel?.data?._id) {
      handleUpdate(payload);
    } else {
      handleAdd(payload);
    }
  };

  useEffect(() => {
    if (allmodel && allmodel?.data?._id) {
      setFormData(allmodel.data);
    }
  }, []);

  return (
    <div className="fixed inset-0 z-10">
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
          <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="px-6 py-8">
              <h2 className="text-lg font-medium text-gray-900 mb-6">
                {allmodel?.data?._id ? <>Update Patient</> : <>Add Patient</>}
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                {[
                  { key: 'firstName', label: 'First Name' },
                  { key: 'lastName', label: 'Last Name' },
                  { key: 'email', label: 'Email', type: 'email' },
                  { key: 'phone', label: 'Phone', type: 'tel' },
                  //{ key: 'gender', label: 'Gender', type: 'text' },
                  { key: 'medicalCase', label: 'Medical Case', type: 'text' },
                ].map(({ key, label, type = 'text' }) => (
                  <div key={key} className="flex items-center gap-4">
                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">{label}</label>
                    <input
                      type={type}
                      value={formData[key] || ''}
                      onChange={(e) => handleInputChange(key, e.target.value)}
                      required
                      className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                    />
                  </div>
                ))}

                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Gender</label>
                  <select
                    value={formData.gender || ''}
                    onChange={(e) => handleInputChange('gender', e.target.value)}
                    required
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  >
                    <option value="" disabled>
                      Select Gender
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>


                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-3">
                    <label
                      htmlFor="cover-photo"
                      className="block text-sm font-medium text-gray-900 mb-2 text-justify"
                    >
                      Menu
                    </label>
                  </div>

                  <div className="col-span-9">
                    {formData.attachments.length === 0 ? (
                      <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                        <PhotoIcon
                          aria-hidden="true"
                          className="text-gray-300 h-12 w-12 mb-2"
                        />
                        <div className="flex items-center text-sm text-gray-600">
                          <label
                            htmlFor="file-upload-menus"
                            className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                          >
                            <span>Upload a file</span>
                            <input
                              id="file-upload-menus"
                              name="file-upload"
                              type="file"
                              multiple
                              required
                              accept="image/jpeg,image/png,image/jpg,application/pdf"
                              onChange={(e) => handleImageUpload("attachments", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                          <p className="pl-2">or drag and drop</p>
                        </div>
                        <p className="mt-2 text-xs text-gray-500">PNG, JPG,JPEG up to 10MB</p>
                      </div>
                    ) : (
                      <div className="flex flex-wrap gap-4">
                        {formData.attachments.map((url, index) => (
                          <div key={index} className="relative w-1/2 sm:w-1/3 lg:w-1/4">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${url}`}
                              className="w-full h-40 object-cover rounded-lg sm:h-32 lg:h-48"
                            />
                            <div onClick={() => handleRemoveImage("attachments", index)} className="absolute top-2 right-2 z-10">
                              <TrashIcon className="h-6 w-6 text-gray-700 cursor-pointer" />
                            </div>
                          </div>
                        ))}
                        <div className="w-1/2 sm:w-1/3 lg:w-1/4 flex items-center justify-center">
                          <label
                            htmlFor="file-upload-menus"
                            className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                          >
                            <span>Add Image</span>
                            <input
                              id="file-upload-menus"
                              name="file-upload"
                              type="file"
                              multiple
                                  accept="image/jpeg,image/png,image/jpg,application/pdf"
                              onChange={(e) => handleImageUpload("attachments", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>


                <div className="flex gap-2 mt-4">
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="w-1/2 rounded-md bg-gray-500 px-4 py-3 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:text-sm"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                  >
                    {allmodel?.data?._id ? 'Update' : 'Add'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPatient;
